import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Store from './store';
import App from './App';
import { Router } from 'react-router-dom';
import { amplifyConfig } from './utils/awsConfig';
import history from '../src/utils/history';
import './styles/styles.scss';

amplifyConfig();

document.cookie = 'audience.consent.analytics=allow; SameSite=None; Secure';

ReactDOM.render(
  <Provider store={Store}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_CAPTCHA_KEY}
      language="es-419"
      scriptProps={{
        defer: true,
      }}
    >
      <Router history={history}>
        <App />
      </Router>
    </GoogleReCaptchaProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
